import { createTheme, type MantineColorsTuple } from '@mantine/core';


export const DARK_COLORS: MantineColorsTuple = [
  '#dbdbdb', // [0] lightest (text color)
  '#b0b1ba', // [1]
  '#8a8c98', // [2]
  '#6b6d7c', // [3]
  '#505264', // [4]
  '#3a3b4f', // [5]
  '#1d1f2a', // [6] content background (lighter)
  '#151825', // [7] main background (darker)
  '#11131e', // [8] very dark
  '#0c0e17', // [9] darkest
];

export const BLUE_COLORS: MantineColorsTuple = [
  '#e2f7f9', // [0] lightest
  '#c1e8ec', // [1]
  '#9ed9df', // [2]
  '#79c9d1', // [3]
  '#59bac5', // [4]
  '#479ca5', // [5] nvicta blue base
  '#3b8890', // [6]
  '#31747c', // [7]
  '#296168', // [8]
  '#204e54', // [9] darkest
];

export const GREEN_COLORS: MantineColorsTuple = [
  '#ffffff', // 0
  '#e3ede8', // 1
  '#c7dcd2', // 2
  '#abcbbc', // 3
  '#8fbaa5', // 4
  '#738a8e', // 5
  '#577877', // 6
  '#3b665f', // 7
  '#1f5447', // 8
  '#046536', // 9 (base)
];

export const MAIN_RED = '#e8436b'; // nvicta red base
export const MAIN_GREEN = '#046536';
export const HIGHTLIGHT_COLOR = '#ff9901';

export const nptlabsTheme = createTheme({
  // primaryColor: 'nvictaPrimary',
  colors: {
    dark: DARK_COLORS,
    blue: BLUE_COLORS,
    green: GREEN_COLORS,
  },
  
  fontFamily: 'Roboto, sans-serif',
  headings: {
    fontFamily: 'Roboto, sans-serif',
    sizes: {
      h1: { fontSize: '2.5rem' },
      h2: { fontSize: '2rem' },
    },
  },
  defaultRadius: 'md',
});
